import Vue from "vue";
import Router from "vue-router";

import HomePage from "../home/HomePage.vue";
import RobotBuilder from "../build/RobotBuilder.vue";
import PartInfo from "../parts/PartInfo.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: HomePage
    },
    {
      path: "/build",
      name: "Build",
      component: RobotBuilder
    },
    {
      path: "/parts/:partType/:id",
      name: "Parts",
      component: PartInfo
    }
  ]
});
